import type { ReactNode } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

interface TeamPageShellProps {
  children: ReactNode;
}

export default function TeamPageShell({ children }: TeamPageShellProps) {
  return (
    <Box>
      <div className="row mx-0">
        <div className="col-md-12 mb-3">
          <div className="card custom-card">
            <div className="card-header d-flex justify-content-between align-items-center py-2">
              <Typography variant="h2">Team Members</Typography>
              <Button variant="contained" color="primary" size="small" startIcon={<PersonAddIcon />} disabled>
                Invite Employee
              </Button>
            </div>
            <div className="card-body">
              <Stack direction="row" spacing={2} sx={{ mb: 3 }} flexWrap="wrap">
                <TextField
                  size="small"
                  label="Search"
                  placeholder="Search by name or email"
                  disabled
                  sx={{ minWidth: 240 }}
                />
                <FormControl size="small" sx={{ minWidth: 150 }} disabled>
                  <InputLabel>Filter by Role</InputLabel>
                  <Select label="Filter by Role" value="">
                    <MenuItem value="">All</MenuItem>
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 150 }} disabled>
                  <InputLabel>Sort By</InputLabel>
                  <Select label="Sort By" value="newest">
                    <MenuItem value="newest">Newest First</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
              <div className="row">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
